/**
 * @file user-agent/library.js
 * @description This library detects the user agent and determines if the user
 * is from Facebook, Twitter, Google, or others.
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 */

export function isSafari() {
    return (
        navigator.vendor.match(/apple/i) &&
        !navigator.userAgent.match(/crios/i) &&
        !navigator.userAgent.match(/fxios/i) &&
        !navigator.userAgent.match(/Opera|OPT\//)
    );
}

export function isAndroid() {
    return Boolean(navigator.userAgent.match(/Android/i));
}

export function isAppleDevice() {
    // iOS
    return Boolean(navigator.userAgent.match(/iPhone|iPad|iPod/i));
}

export function isMobileDevice() {
    return isAppleDevice() || isAndroid();
}
